module.exports = __webpack_public_path__ + "10cc19bd484118dbcd0a7886a38ceddc.png";